/* Bioteine - Fase test
 * Standalone module. Initializes any [data-bt-fase-test] forms on the page.
 * Result flow: result reveal -> plan email capture -> phase product reco -> coach onboarding.
 */
(function () {
  'use strict';

  /* Fallback copy if the section's localized JSON is missing */
  var FALLBACK_COPY = {
  '1': { title: 'Fase 1 - Power Start', body: 'Je past het best bij Fase 1.', url: '/collections/fase-1' },
  '2': { title: 'Fase 2 - Combi', body: 'Je past het best bij Fase 2.', url: '/collections/fase-2' },
  '3': { title: 'Fase 3 - Overgang', body: 'Je past het best bij Fase 3.', url: '/collections/fase-3' },
  '4': { title: 'Fase 4 - Levensstijl', body: 'Je past het best bij Fase 4.', url: '/collections/fase-4' }
  };

  function init(form) {
  if (form.dataset.btFaseTestInited === '1') return;
  form.dataset.btFaseTestInited = '1';

  var qs = Array.prototype.slice.call(form.querySelectorAll('.bt-fase-test__q'));
  var result = form.querySelector('[data-bt-result]');
  if (!qs.length || !result) {
  console.warn('[bt-fase-test] no questions or result panel found');
  return;
  }

  var COPY = FALLBACK_COPY;
  var copyEl = form.querySelector('script[data-bt-copy]');
  if (copyEl) {
  try { COPY = JSON.parse(copyEl.textContent); } catch (e) { console.warn('[bt-fase-test] copy JSON parse failed', e); }
  }

  var idx = 0;
  var total = qs.length;
  var computedPhase = null;
  var customerEmail = form.dataset.customerEmail || '';
  var customerFirstName = form.dataset.customerFirstName || '';

  function show(i) {
  for (var j = 0; j < qs.length; j++) {
  if (j === i) {
  qs[j].hidden = false;
  qs[j].removeAttribute('hidden');
  qs[j].style.display = '';
  } else {
  qs[j].hidden = true;
  qs[j].setAttribute('hidden', '');
  }
  }
  idx = i;
  }

  function getChecked(q) {
  return q.querySelector('input[type="radio"]:checked');
  }

  function compute() {
  var scores = { '1': 0, '2': 0, '3': 0, '4': 0 };
  var allChecked = form.querySelectorAll('input[type="radio"]:checked');
  for (var i = 0; i < allChecked.length; i++) {
  var p = allChecked[i].getAttribute('data-phase');
  if (scores[p] !== undefined) scores[p]++;
  }
  var winner = '1', best = -1;
  Object.keys(scores).forEach(function (k) {
  if (scores[k] > best) { best = scores[k]; winner = k; }
  });
  computedPhase = winner;
  var pick = COPY[winner] || FALLBACK_COPY[winner];

  // Pre-fill plan + coach email with logged-in customer's details
  var planEmail = form.querySelector('[name="plan_email"]');
  var coachEmail = form.querySelector('[name="coach_email"]');
  var coachFirstName = form.querySelector('[name="coach_first_name"]');
  if (planEmail && !planEmail.value && customerEmail) planEmail.value = customerEmail;
  if (coachEmail && !coachEmail.value && customerEmail) coachEmail.value = customerEmail;
  if (coachFirstName && !coachFirstName.value && customerFirstName) coachFirstName.value = customerFirstName;

  var titleEl = result.querySelector('[data-bt-result-title]');
  var bodyEl = result.querySelector('[data-bt-result-body]');
  if (titleEl) titleEl.textContent = pick.title;
  if (bodyEl) bodyEl.textContent = pick.body;

  // Reveal the recommended product for this phase only
  var recos = result.querySelectorAll('[data-bt-reco]');
  for (var r = 0; r < recos.length; r++) {
  if (recos[r].getAttribute('data-fase') === winner) {
  recos[r].hidden = false;
  recos[r].removeAttribute('hidden');
  } else {
  recos[r].hidden = true;
  recos[r].setAttribute('hidden', '');
  }
  }

  for (var k = 0; k < qs.length; k++) {
  qs[k].hidden = true;
  qs[k].setAttribute('hidden', '');
  }
  result.hidden = false;
  result.removeAttribute('hidden');
  try { result.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}

  try {
  var queue = window._learnq = window._learnq || [];
  queue.push(['track', 'Fase Test Completed', { phase: winner }]);
  } catch (e) {}
  }

  // Delegated click handler for all step/plan/coach actions
  form.addEventListener('click', function (e) {
  var t = e.target.closest('[data-bt-next], [data-bt-prev], [data-bt-submit], [data-bt-restart], [data-bt-plan-submit], [data-bt-coach-open], [data-bt-coach-skip], [data-bt-coach-submit]');
  if (!t) return;
  e.preventDefault();

  if (t.hasAttribute('data-bt-next')) {
  var cur = qs[idx];
  if (!getChecked(cur)) {
  cur.classList.add('is-error');
  var legend = cur.querySelector('.bt-fase-test__q-num');
  if (legend) legend.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return;
  }
  cur.classList.remove('is-error');
  if (idx < total - 1) show(idx + 1);
  return;
  }

  if (t.hasAttribute('data-bt-prev')) {
  if (idx > 0) show(idx - 1);
  return;
  }

  if (t.hasAttribute('data-bt-submit')) {
  var last = qs[idx];
  if (!getChecked(last)) {
  last.classList.add('is-error');
  return;
  }
  compute();
  return;
  }

  if (t.hasAttribute('data-bt-restart')) {
  var radios = form.querySelectorAll('input[type="radio"]');
  for (var i = 0; i < radios.length; i++) radios[i].checked = false;
  result.hidden = true;
  result.setAttribute('hidden', '');
  var planBox = form.querySelector('[data-bt-plan]');
  var planOk = form.querySelector('[data-bt-plan-success]');
  if (planBox) planBox.hidden = false;
  if (planOk) { planOk.hidden = true; planOk.setAttribute('hidden', ''); }
  show(0);
  form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  return;
  }

  if (t.hasAttribute('data-bt-plan-submit')) {
  submitPlan(t);
  return;
  }

  if (t.hasAttribute('data-bt-coach-open')) {
  var cta = form.querySelector('[data-bt-coach-cta]');
  var fm = form.querySelector('[data-bt-coach-form]');
  if (cta) cta.hidden = true;
  if (fm) { fm.hidden = false; try { fm.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {} }
  return;
  }

  if (t.hasAttribute('data-bt-coach-skip')) {
  var fm2 = form.querySelector('[data-bt-coach-form]');
  var cta2 = form.querySelector('[data-bt-coach-cta]');
  if (fm2) fm2.hidden = true;
  if (cta2) cta2.hidden = true;
  return;
  }

  if (t.hasAttribute('data-bt-coach-submit')) {
  submitCoach(t);
  return;
  }
  });

  function submitPlan(btn) {
  var emailEl = form.querySelector('[name="plan_email"]');
  var errEl = form.querySelector('[data-bt-plan-error]');
  if (!emailEl || !emailEl.value || emailEl.value.indexOf('@') === -1) {
  if (errEl) errEl.hidden = false;
  if (emailEl) emailEl.focus();
  return;
  }
  if (errEl) { errEl.hidden = true; errEl.setAttribute('hidden', ''); }
  var origLabel = btn.textContent;
  btn.disabled = true; btn.textContent = '...';

  var props = {
  'fase_test_result': computedPhase || '1',
  'fase_test_plan_requested': true,
  'fase_test_completed_at': new Date().toISOString().slice(0, 10)
  };

  var showSuccess = function () {
  var planBox = form.querySelector('[data-bt-plan]');
  var planOk = form.querySelector('[data-bt-plan-success]');
  if (planBox) { planBox.hidden = true; planBox.setAttribute('hidden', ''); }
  if (planOk) { planOk.hidden = false; planOk.removeAttribute('hidden'); }
  // carry the email into the coach form so that step is one field lighter
  var coachEmail = form.querySelector('[name="coach_email"]');
  if (coachEmail && !coachEmail.value) coachEmail.value = emailEl.value;
  btn.disabled = false; btn.textContent = origLabel;
  };

  var fireTrack = function () {
  try {
  var queue = window._learnq = window._learnq || [];
  queue.push(['track', 'Fase Plan Requested', { phase: computedPhase || '1', source: 'fase-test' }]);
  } catch (e) {}
  };

  if (window.BTKlaviyo && window.BTKlaviyo.subscribeAndIdentify) {
  window.BTKlaviyo.subscribeAndIdentify(emailEl.value, props, 'fase-test-plan')
  .then(function () { fireTrack(); showSuccess(); })
  .catch(function (err) {
  console.error('[bt-plan] subscribe failed, falling back to identify-only', err);
  try {
  var queue = window._learnq = window._learnq || [];
  var idProps = { '$email': emailEl.value };
  Object.keys(props).forEach(function (k) { idProps[k] = props[k]; });
  queue.push(['identify', idProps]);
  } catch (e) {}
  fireTrack();
  showSuccess();
  });
  } else {
  console.warn('[bt-plan] BTKlaviyo.subscribeAndIdentify missing, using identify-only fallback');
  try {
  var queue = window._learnq = window._learnq || [];
  var idProps2 = { '$email': emailEl.value };
  Object.keys(props).forEach(function (k) { idProps2[k] = props[k]; });
  queue.push(['identify', idProps2]);
  } catch (e) {}
  fireTrack();
  setTimeout(showSuccess, 600);
  }
  }

  function submitCoach(btn) {
  var fm = form.querySelector('[data-bt-coach-form]');
  var errEl = form.querySelector('[data-bt-coach-error]');
  var emailEl = form.querySelector('[name="coach_email"]');
  if (!emailEl || !emailEl.value || emailEl.value.indexOf('@') === -1) {
  var planErr = form.querySelector('[data-bt-plan-error]');
  if (errEl) { errEl.textContent = planErr ? planErr.textContent : 'Vul een geldig e-mailadres in.'; errEl.hidden = false; }
  if (emailEl) emailEl.focus();
  return;
  }
  if (errEl) errEl.hidden = true;
  btn.disabled = true; btn.textContent = '...';

  function v(name) { var el = form.querySelector('[name="' + name + '"]'); return el ? el.value : ''; }
  function n(name) { var s = v(name); return s ? Number(s) : null; }
  var consent = !!(form.querySelector('[name="coach_consent_weekly"]') || {}).checked;

  var nowIso = new Date().toISOString().slice(0, 10);
  var properties = {
  '$email': emailEl.value,
  '$first_name': v('coach_first_name') || undefined,
  'coach_phase': computedPhase || '1',
  'coach_goal_weight_kg': n('coach_goal_weight_kg'),
  'coach_current_weight_kg': n('coach_current_weight_kg'),
  'coach_starting_weight_kg': n('coach_current_weight_kg'),
  'coach_height_cm': n('coach_height_cm'),
  'coach_exercise_freq': v('coach_exercise_freq'),
  'coach_dietary': v('coach_dietary'),
  'coach_hates': v('coach_hates') || undefined,
  'coach_consent_weekly': consent,
  'coach_started_at': nowIso,
  '$source': 'fase-test-onboarding'
  };
  // strip null/undefined/empty
  Object.keys(properties).forEach(function (k) {
  if (properties[k] === null || properties[k] === undefined || properties[k] === '') delete properties[k];
  });

  // Strip $email from properties. The helper handles it as the dedicated `email` field.
  // Also strip $first_name and $source so they don't double-apply via Subscribe API.
  var subscribeProps = {};
  Object.keys(properties).forEach(function (k) {
  if (k !== '$email' && k !== '$first_name' && k !== '$source') {
  subscribeProps[k] = properties[k];
  }
  });
  // first_name goes through as a top-level Klaviyo profile attribute via properties
  if (properties['$first_name']) subscribeProps.first_name = properties['$first_name'];

  var showSuccess = function () {
  var success = form.querySelector('[data-bt-coach-success]');
  if (fm) fm.hidden = true;
  if (success) {
  // Personal goal echo: "from X to Y kg" when both weights were filled in
  var echo = success.querySelector('[data-bt-goal-echo]');
  var from = properties.coach_current_weight_kg;
  var to = properties.coach_goal_weight_kg;
  if (echo && from && to && to < from) {
  echo.textContent = (echo.getAttribute('data-template') || '').replace('%FROM%', from).replace('%TO%', to);
  echo.hidden = false;
  echo.removeAttribute('hidden');
  }
  success.hidden = false;
  success.removeAttribute('hidden');
  try { success.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }
  };

  var fireTrackEvent = function () {
  try {
  var queue = window._learnq = window._learnq || [];
  queue.push(['track', 'Coach Onboarded', {
  phase: computedPhase || '1',
  consent_weekly: consent,
  goal_weight_kg: properties.coach_goal_weight_kg || null,
  starting_weight_kg: properties.coach_starting_weight_kg || null,
  source: 'fase-test'
  }]);
  } catch (e) { console.warn('[bt-coach] track failed', e); }
  };

  // Use Subscribe API (creates profile + sets properties + SETS MARKETING CONSENT).
  // Without consent, no Klaviyo flow email will deliver to this profile.
  if (window.BTKlaviyo && window.BTKlaviyo.subscribeAndIdentify) {
  window.BTKlaviyo.subscribeAndIdentify(emailEl.value, subscribeProps, 'fase-test-onboarding')
  .then(function () {
  fireTrackEvent();
  showSuccess();
  })
  .catch(function (err) {
  console.error('[bt-coach] subscribe failed, falling back to identify-only', err);
  try {
  var queue = window._learnq = window._learnq || [];
  queue.push(['identify', properties]);
  } catch (e) {}
  fireTrackEvent();
  showSuccess();
  });
  } else {
  console.warn('[bt-coach] BTKlaviyo.subscribeAndIdentify missing, using identify-only fallback');
  try {
  var queue = window._learnq = window._learnq || [];
  queue.push(['identify', properties]);
  } catch (e) {}
  fireTrackEvent();
  setTimeout(showSuccess, 600);
  }
  }

  // Make sure first question is visible on load
  show(0);
  }

  function initAll() {
  var forms = document.querySelectorAll('[data-bt-fase-test]');
  for (var i = 0; i < forms.length; i++) init(forms[i]);
  }

  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
  } else {
  initAll();
  }
})();
